/*
 Licensed Materials - Property of IBM
 5737-I23
 Copyright IBM Corp. 2019. All Rights Reserved.
 U.S. Government Users Restricted Rights:
 Use, duplication or disclosure restricted by GSA ADP Schedule
 Contract with IBM Corp.
 */

// * Select/Boolean
import { CarbonCheckboxWidget } from './CarbonCheckboxWidget';
import { CarbonDropdownWidget } from './CarbonDropdownWidget';

// * String
// generic input
import { CarbonBaseInput } from './CarbonBaseInput';

import { CarbonTextWidget } from './CarbonTextWidget';

export const widgets = {
    BaseInput: CarbonBaseInput,
    CheckboxWidget: CarbonCheckboxWidget,
    SelectWidget: CarbonDropdownWidget,
    TextWidget: CarbonTextWidget
};